import styled from '@emotion/styled'
import { ReactNode } from 'react'

import { ArrowIcon } from './ArrowIcon'
import { useDisclosureContext } from './useDisclosureContext'
import { Color } from '../../constants/color'
import { theme } from '../../constants/theme'

const ExpandIcon = styled.div({
  fontSize: 24,
  marginRight: 12,
  textAlign: 'center',
  width: 18,
})

const HeaderElement = styled.div<{ floating: boolean; isOpen: boolean }>(
  (props) => ({
    alignItems: 'center',
    backgroundColor: props.floating ? undefined : Color.WHITE,
    border: props.floating ? undefined : theme.border.style.thin,
    borderRadius: theme.border.radius.normal,
    borderBottomLeftRadius: props.isOpen ? 0 : undefined,
    borderBottomRightRadius: props.isOpen ? 0 : undefined,
    boxShadow:
      props.isOpen && !props.floating ? theme.boxShadow.elevated : undefined,
    color: props.floating ? Color.BLUE : undefined,
    cursor: 'pointer',
    display: 'flex',
    fontSize: props.floating ? 20 : undefined,
    fontWeight: theme.font.weight.bold,
    overflow: 'hidden',
    padding: props.floating ? undefined : 20,
    paddingBottom: props.floating ? 16 : 20,
    paddingTop: props.floating ? 16 : 20,
    position: 'relative',
    userSelect: 'none',
    '&:hover': {
      background: Color.LIGHT_GREY,
    },
  }),
)

export type HeaderProps = {
  children?: ReactNode
  icon?: boolean
}

export const Header = ({ children, icon }: HeaderProps) => {
  const { floating, isOpen, toggleIsOpen } = useDisclosureContext()

  return (
    <HeaderElement floating={floating} isOpen={isOpen} onClick={toggleIsOpen}>
      {icon &&
        (floating ? (
          <ExpandIcon>{isOpen ? '–' : '+'}</ExpandIcon>
        ) : (
          <ArrowIcon isOpen={isOpen} />
        ))}
      {children}
    </HeaderElement>
  )
}
